import { useCallback } from 'react';

import { isChangePageUrl } from '@change-corgi/core/security';
import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

/**
 * Returns a function that gives back `url` when it's a Change.org page that's safe to redirect to
 * automatically (see `isChangePageUrl`), else `undefined`. Checked against the origin this app is
 * serving from.
 *
 * Callers that need a fallback use `getChangePageUrl(url) ?? '/'`.
 */
export function useGetChangePageUrl(): (url: string | null | undefined) => string | undefined {
	const { resolveUrl } = useUtilityContext();
	return useCallback(
		(url) => (url && isChangePageUrl(url, { baseUrl: resolveUrl('/') }) ? url : undefined),
		[resolveUrl],
	);
}
